module.exports = __webpack_public_path__ + "media/images/favicon/favicon-96x96-8fdc9d1926c4e7d82e3e5c9300c3866d.png";